
let id = Math.random() * 102349598;
function generateId() {
    return ++id
}

export function useId() {
    return generateId()
}